import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 justify-center gap-10 lg:gap-16 items-center mt-[6%]">
      <div
        data-aos="fade-right"
        data-aos-duration="1500"
        className="flex flex-col justify-center items-center lg:items-end"
      >
        <div className="">
          <img
            className="rounded-full mt-10 lg:mt-0 h-[200px] lg:h-[300px] border-cyan-700 border-4 "
            src="https://avatars.githubusercontent.com/u/72511886?v=4"
            alt=""
          />
        </div>
        <p className="text-3xl mt-4 font-semibold">Md. Shahriar Rahman</p>
        <p className="text-base text-center lg:text-right mt-3 max-w-md">
          I am an enthusiastic tech geek. I've completed B.Sc. in CSE from
          Daffodil International University with a target to enrich my
          development skills and to have strong analytical skills. I know myself
          as a self motivated, self problem solver, taking responsibility at
          every step, and a highly disciplined person who can learn a lot during
          any time of the week facing any critical conditions.
        </p>
      </div>
      <div
        className=" text-center lg:text-left"
        data-aos="fade-left"
        data-aos-duration="1500"
      >
        <h2 className="text-4xl font-bold mb-10 text-gray-300 ">Skills</h2>
        <div className="">
          <h2 className="text-3xl mb-6 ">Frontend</h2>
          <div className="flex flex-wrap justify-center lg:justify-start gap-3 lg:gap-0">
            <span className="bg-gradient-to-tr from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b">
              Javascript
            </span>
            <span className="bg-gradient-to-tr from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b">
              ReactJs
            </span>
            <span className="bg-gradient-to-tr from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b">
              NextJs
            </span>
            <span className="bg-gradient-to-tr from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b">
              TailwindCSS
            </span>
            <span className="bg-gradient-to-tr from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b ">
              Bootstraps
            </span>
          </div>
        </div>

        <div>
          <h2 className="text-3xl mb-6 mt-6">Backend</h2>
          <div>
            <span className="bg-gradient-to-r from-cyan-600 to-sky-800 p-2 rounded-lg mr-3 border-b">
              ExpressJs
            </span>
            <span className="bg-gradient-to-r from-cyan-600 to-sky-800 p-2 rounded-lg mr-3 border-b">
              NodeJs
            </span>
          </div>
        </div>
        <div>
          <h2 className="text-3xl mb-6 mt-6">Database</h2>
          <div>
            <span className="bg-gradient-to-r from-sky-600 to-blue-800 p-2 rounded-lg mr-3 border-b">
              MongoDB
            </span>
          </div>
        </div>

        <div>
          <h2 className="text-3xl mb-4 mt-6">Tools</h2>
          <div className="flex flex-wrap justify-center lg:justify-start gap-3 lg:gap-0">
            <span className="bg-gradient-to-tr from-violet-500 to-purple-800 p-2 rounded-lg mr-3 border-b">
              Git
            </span>
            <span className="bg-gradient-to-tr from-violet-500 to-purple-800 p-2 rounded-lg mr-3 border-b">
              Github
            </span>
            <span className="bg-gradient-to-tr from-violet-500 to-purple-800 p-2 rounded-lg mr-3 border-b">
              Firebase
            </span>
            <span className="bg-gradient-to-tr from-violet-500 to-purple-800 p-2 rounded-lg mr-3 border-b">
              Netlify
            </span>
            <span className="bg-gradient-to-tr from-violet-500 to-purple-800 p-2 rounded-lg mr-3 border-b">
              Vercel
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
